import React from 'react';
import { FormGroup, Label, Input, Container, Row, Col, Card, CardBody, CardFooter, ListGroup, ListGroupItem } from 'reactstrap';
import MapWithSearch from 'Component/Maps/LeafletGeosearchMap/MapWithSearch';
import { useSelector } from 'react-redux';
import { Btn, H5, Image } from 'AbstractElements';
import { useNavigate } from 'react-router';
import CarouselBannerBranch from '../CarouselBannerBranch'; 
import { GetAdminRole } from 'Component/Common/GetAdminRole';
import { useParams, useLocation } from 'react-router-dom';

const DetailContent = ({ handleAttachTreatment, handleAttachDoctor, handleAttachSetup, handleBack }) => {
    const data = useSelector(state => state.branch.currentBranch)
    const history = useNavigate();
    const user = JSON.parse(localStorage.getItem('USER'));
    const role = GetAdminRole(user);
    const location = useLocation();
    const isClinicsRoute = location.pathname.includes('/clinics');
    const isDoctorsRoute = location.pathname.includes('/doctors');
    const isSettingsRoute = location.pathname.includes('/settings');
    
    return (
        <Container fluid={true}>
            <Row>
                <Col sm="12" lg="12" xl="12">
                    <Card>
                    <CardBody className="add-post">
                            <Row>
                                <Col xs="12" sm="12" md="6" lg="6" xl={data.bannerLink?.length === 1 ? "6" : "8"}>
                                    <ListGroup flush>
                                        <ListGroupItem>
                                            <H5><i className="fa fa-edit fa-lg pe-2"></i> {data.name || "-"}</H5>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <H5><i className="fa fa-phone-square fa-lg pe-2"></i> {data.phone || "-"}</H5>
                                        </ListGroupItem>
                                        <ListGroupItem>
                                            <Row className="align-items-start">
                                                <Col xs="auto" className="pe-0">
                                                    <i className="fa fa-home fa-lg"></i>
                                                </Col>
                                                <Col>
                                                    <H5>{data.location || "-"}</H5>
                                                </Col>
                                            </Row>
                                        </ListGroupItem>
                                        <ListGroup flush>
                                            <ListGroupItem>
                                                <H5><i className="fa fa-clock-o fa-lg pe-2"></i> Jam Operasional</H5>
                                                <ul className="m-0 ps-3">
                                                    {Object.entries(data.operation_hours).map(([day, status]) => (
                                                        <li key={day}>
                                                            <strong style={{ display: "inline-block", minWidth: "80px" }}>{day}</strong> : {status}
                                                        </li>
                                                    ))}
                                                </ul>
                                            </ListGroupItem>
                                        </ListGroup>
                                    </ListGroup>
                                </Col>

                                <Col xs="12" sm="12" md="6" lg="6" xl="3" className="mt-sm-0 mt-3">
                                    <H5>Foto Klinik</H5>
                                    <Image
                                        attrImage={{
                                            className: 'img-fluid w-70',
                                            src: data.photosLink,
                                            alt: data.name,
                                            style: { height: 'auto', borderRadius: '8px', maxWidth: '300px' }
                                        }}
                                    />
                                </Col>

                                {data.bannerLink && data.bannerLink.length === 1 ? (
                                <Col xs="12" sm="12" md="6" lg="6" xl="3" className="mt-sm-0 mt-3">
                                    <H5>Galeri Foto Klinik</H5>
                                    <Image
                                        attrImage={{
                                            className: 'img-fluid',
                                            src: data.bannerLink[0].url,
                                            alt: data.name,
                                            style: { height: 'auto', width: '100%', maxWidth: '300px', objectFit: 'cover', borderRadius: '8px' }
                                        }}
                                    />
                                </Col>
                                ) : null}
                                
                                {data.bannerLink && data.bannerLink.length > 1 ? (
                                    <Col xs="12" sm="12" md="12" lg="12" xl="8" className="mt-3"> 
                                        <CarouselBannerBranch
                                            slides={2}
                                            title="Galeri Foto Klinik"
                                            rtl={true}
                                            lazyLoad={false}
                                            autoplay={true}
                                            images={data.bannerLink}
                                            readOnly
                                        />
                                    </Col>
                                ) : null}

                                <Col xs="12" sm="12" md="12" lg="12" xl="4" className="mt-3">
                                    <H5>Lokasi Klinik</H5>
                                    <MapWithSearch initialPosition={{ lat: data.latitude || -7.778287962362472, lng: data.longitude || 110.3927722584372 }} readOnly />
                                </Col>
                            </Row>
                    </CardBody>
                        <CardFooter className="add-post">
                            <div className="btn-showcase text-end">
                                {/* Edit Button */}
                                <Btn attrBtn={{ color: "primary", type: "button", onClick: () => history(`${process.env.PUBLIC_URL}/clinics/branch/edit/${data.id}`) }}>
                                    <i className="fa fa-edit fa-lg"></i> Edit
                                </Btn>

                                {/* Conditionally render buttons for super_admin */}
                                {role === 'super_admin' && (
                                    <>
                                        <Btn attrBtn={{ color: "light", type: "button", onClick: handleBack }}>
                                            <i className="fa fa-arrow-circle-left fa-lg"></i> Kembali
                                        </Btn>
                                        {['handleAttachTreatment', 'handleAttachDoctor', 'handleAttachSetup'].map((action, idx) => (
                                            <Btn
                                                key={idx}
                                                attrBtn={{ color: "primary", type: "submit", onClick: eval(action) }}
                                            >
                                                <i className={`fa fa-plus-circle fa-lg`}></i> {action === 'handleAttachTreatment' ? 'Tambahkan Perawatan' : action === 'handleAttachDoctor' ? 'Tambahkan Dokter' : 'Atur Jadwal'}
                                            </Btn>
                                        ))}
                                    </>
                                )}

                                {/* Conditionally render buttons for admin */}
                                {role === 'admin' && (
                                    <>
                                        {isClinicsRoute && (
                                            <Btn attrBtn={{ color: "primary", type: "submit", onClick: handleAttachTreatment }}>
                                                <i className="fa fa-plus-circle fa-lg"></i> Tambahkan Perawatan
                                            </Btn>
                                        )}
                                        {isDoctorsRoute && (
                                            <Btn attrBtn={{ color: "primary", type: "submit", onClick: handleAttachDoctor }}>
                                                <i className="fa fa-plus-circle fa-lg"></i> Tambahkan Dokter
                                            </Btn>
                                        )}
                                        {isSettingsRoute && (
                                            <Btn attrBtn={{ color: "primary", type: "submit", onClick: handleAttachSetup }}>
                                                <i className="fa fa-plus-circle fa-lg"></i> Atur Jadwal
                                            </Btn>
                                        )}
                                    </>
                                )}
                            </div>
                        </CardFooter>

                    </Card>
                </Col>
            </Row>
        </Container>
    );
};

export default DetailContent;